import { useContext, type ReactNode } from 'react';
import { OrganisationFilterSlot } from './organisationFilterSlot.ts';
import { PageTitle } from './PageTitle.tsx';

export interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /* Sits right of the title, e.g. a "Track ended" badge. */
  badge?: ReactNode;
  /* The page's own filters, after the organisation picker. */
  filters?: ReactNode;
}

/*
 * Every console page starts with this: the title on the left, the filters on
 * the right of the same line, the organisation first among them.
 */
export function PageHeader({ title, subtitle, badge, filters }: PageHeaderProps) {
  const organisation = useContext(OrganisationFilterSlot);

  return (
    <header className='flex flex-wrap items-start justify-between gap-x-8 gap-y-4'>
      <div className='flex min-w-0 flex-col gap-2'>
        <div className='flex items-center gap-4'>
          <PageTitle>{title}</PageTitle>
          {badge}
        </div>
        {subtitle && <p className='text-base text-ink-muted'>{subtitle}</p>}
      </div>

      <div className='flex flex-wrap items-center gap-x-5 gap-y-2'>
        {organisation}
        {filters}
      </div>
    </header>
  );
}
